import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from './theme';

const ThemeContext = createContext();

export const useThemeContext = () => {
    return useContext(ThemeContext);
};

export const ThemeContextProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        try {
            const stored = localStorage.getItem('nybanq_dark_mode');
            return stored === 'true';
        } catch (e) {
            return false;
        }
    });

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        try {
            localStorage.setItem('nybanq_dark_mode', isDarkMode);
        } catch (e) {
            // Ignore storage errors
        }
    }, [isDarkMode]);

    const toggleTheme = () => {
        setIsDarkMode(prev => !prev);
    };

    // Force light theme on mobile, otherwise respect user preference
    const activeTheme = (isMobile ? false : isDarkMode) ? darkTheme : lightTheme;

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme, isMobile }}>
            <ThemeProvider theme={activeTheme}>
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
};
